import React, { Component } from 'react';
import axios from 'axios';
import LoadSpinner from '../shared/loadSpinner';
import AccessPad from '../shared/accessPad';

import Switch from "react-switch";

import ReactTable from 'react-table';
import "react-table/react-table.css";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css'

const ReactTableFixedColumns = withFixedColumns(ReactTable);

class UserManagement extends Component{
    constructor(props) {
        super(props);
        this.state = {
            userList:[],
            openPwdTray: false,
            loading: false,
            displaySlider: false,
            pwdIdx: null
        }  
        
        this.chartCol = [
            { 
                Header: "", width: 40, Cell: row => { 
                    return <div className="user-icon" onClick={() => this.removeUser(row.index)}><i className="base fas fa-user" /> <i className="hover fas fa-minus" /></div> 
                } 
            },
            { 
                Header: "User Name", accessor: "name",
                Cell: row =>{ return <input name="name" idx={row.index} value={row.row.name} autoComplete="off" onChange={this.handleChange} />; }
            },
            { 
                Header: "User Id", accessor: "userId",
                Cell: row =>{ return <input name="userId" idx={row.index} value={row.row.userId} autoComplete="off" onChange={this.handleChange} />; }
            },
            { 
                Header: "Face Id", accessor: "faceId",
                Cell: row =>{ return <input name="faceId" idx={row.index} value={row.row.faceId} autoComplete="off" onChange={this.handleChange} />; }
            },
            { 
                Header: "Admin", width: 120, accessor: "admin",
                Cell: row => { return <Switch className="input-switch" height={20} checked={row.row.admin} onChange={() => this.handleSwitchChange(row.row.admin, row.index) } />; }
            },
            { 
                Header: "Password", width: 120, Cell: row => { 
                    return <div className="btn-container tbl-btn" onClick={() => this.resetSlider(row.index)}>
                                <div className="tro-btn btn">
                                    <div className="btn-txt">{("_id" in row.row._original ? "Reset" : "Set")}</div>
                                    <div className="btn-icon">
                                        <i className="fas fa-fingerprint" />
                                    </div>
                                </div>
                            </div>;
                } 
            },
            { 
                Header: "Save", width: 100, Cell: row => { 
                    return <div className="btn-container tbl-btn" onClick={()=> this.saveUser(row.index)}>
                                <div className="tro-btn btn save">
                                    <div className="btn-txt">Save</div>
                                    <div className="btn-icon">
                                        <i className="far fa-save" />
                                    </div>
                                </div>
                            </div>;
                } 
            }
        ];

        // References
        this.sliderRef = React.createRef();

        this.submitKey = this.submitKey.bind(this);
        this.newUser = this.newUser.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.removeUser = this.removeUser.bind(this);
        this.resetSlider = this.resetSlider.bind(this);
        this.getUserList = this.getUserList.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getSelectHeight = this.getSelectHeight.bind(this);
    }

    submitKey(keyId) {
        var self = this;
        try {
            if(this.state.pwdIdx === null) {
                this.setState({ displaySlider: false });
            }
            else if("_id" in self.state.userList[self.state.pwdIdx]) {  
                var user = this.props.checkUser(false,true);

                this.setState({ loading: true }, () => {

                    var aUser = self.state.userList[self.state.pwdIdx];
                    var postData = { "user": user, "aUser":{ pwd: keyId, _id: aUser._id } };

                    axios.post(self.props.baseUrl + "/api/auth/resetPwd", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error || !response.data.results){
                            console.log(" [Error] Reseting User Password: ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {   
                            alert("Password Reset");                    
                            self.setState({ loading: false, displaySlider: false });
                        }
                    });    
                }); 
            }
            else {
                // New User
                var tmpUsers = self.state.userList.map(row => row);
                tmpUsers[self.state.pwdIdx].pwd = keyId;

                self.setState({ displaySlider: false, userList: tmpUsers });
            }
        }
        catch(ex){
            console.log("[Error] submitting key: ",ex);
        }
    }

    newUser() {
        try {
            var tmpList = this.state.userList.map(row => row);
            tmpList.unshift({"name":"", "userId":"", "faceId":"","admin":false, "pwd":"" });
            this.setState({ userList: tmpList });
        }
        catch(ex){
            console.log("[Error] adding user: ",ex);
        }
    }

    saveUser(loc){
        var self = this;
        try {
            var tmpUsers = self.state.userList.map(row => row);
            var user = this.props.checkUser(false,true);

            this.setState({ loading: true }, () => {
                var postData = { "user": user, "aUser": tmpUsers[loc] };

                if("_id" in tmpUsers[loc]){
                    axios.post(self.props.baseUrl + "/api/auth/update", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        self.setState({ loading: false }, () =>{
                            if(response.data.error || !response.data.results){
                                console.log(" [Error] Updating User: ", response.data.error); 
                            }
                            else {   
                                alert("Updated User"); 
                            }
                        });
                    });    
                }
                else {
                    // New User
                    if(!("name" in tmpUsers[loc]) || tmpUsers[loc].name.length <= 0){
                        alert("Please set Name for new user before saving");
                        self.setState({ loading: false });
                    }
                    else if(!("userId" in tmpUsers[loc]) || tmpUsers[loc].userId.length <= 0){
                        alert("Please set UserId for new user before saving");
                        self.setState({ loading: false });
                    }
                    else if(!("pwd" in tmpUsers[loc]) || tmpUsers[loc].pwd.length <= 0){
                        alert("Please set Password for new user before saving");
                        self.setState({ loading: false });
                    }
                    else {
                        axios.post(self.props.baseUrl + "/api/auth/create", postData, {'Content-Type': 'application/json'})
                        .then(function(response) {
                            if(response.data.error){
                                console.log(" [Error] Creating User: ", response.data.error); 
                            }
                            else {   
                                tmpUsers[loc]._id = response.data.results;
                                alert("Created User"); 
                            }
                            self.setState({ loading: false, userList: tmpUsers });
                        });    
                    }
                }
            });
            
        }
        catch(ex){
            console.log("[Error] saving user: ",ex);
        }
    }

    removeUser(loc){
        var self = this;
        try {
            var tmpUsers = self.state.userList.map(row => row);

            if("_id" in tmpUsers[loc]){
                var user = this.props.checkUser(false,true);

                this.setState({ loading: true }, () => {
                    var postData = { "user": user, "id": tmpUsers[loc]._id };

                    axios.post(self.props.baseUrl + "/api/auth/remove", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error || !response.data.results){
                            console.log(" [Error] Removing User: ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {   
                            alert("Removed User");  
                            tmpUsers.splice(loc,1);                  
                            self.setState({ loading: false, userList: tmpUsers });
                        }
                    });    
                }); 
            }
            else {
                // New User
                tmpUsers.splice(loc,1);
                this.setState({ userList: tmpUsers });
            }
        }
        catch(ex){
            console.log("[Error] removing user: ",ex);
        }
    }

    resetSlider(pwdIdx) {
        try {
            this.setState({ displaySlider: true, pwdIdx: pwdIdx });
        }
        catch(ex){
            console.log("[Error] submitting key: ",ex);
        }
    }

    getUserList(){
        var self = this;
        try {
            var user = this.props.checkUser(false,true);

            this.setState({ loading: true }, () => {
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                axios.get(self.props.baseUrl + "/api/auth/getUsers", { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting User List Results: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {                       
                        self.setState({ loading: false, userList: response.data.results});
                    }
                });    
            }); 
        }
        catch(ex){
            console.log("[Error] Getting User List: ", ex);
        }
    }

    handleSwitchChange(status, idx){
        try {
            var tmpList = this.state.userList.map(row => row);
            tmpList[idx].admin = !status;
            this.setState({ userList: tmpList });
        }
        catch(ex){
            console.log(" [Error] handling switch change data: ",ex);
        }
    }

    handleChange(e){
        try {
            var tmpList = this.state.userList.map(row => row);
            var name = e.target.name;
            var value = e.target.value;
            var idx = parseInt(e.target.getAttribute('idx'));

            tmpList[idx][name] = value;
            this.setState({ userList: tmpList });
        }
        catch(ex){
            console.log(" [Error] handling change data: ",ex);
        }
    }

    getSelectHeight(){
        var ret = -600;
        try {
            if((this.sliderRef.current && this.sliderRef.current !== null) || this.state.displaySlider){
                ret = (this.state.displaySlider ? 0 : (-1.0 * this.sliderRef.current.clientHeight));
            }
        }
        catch(ex){
            console.log("[Error] Getting Select Height: ",ex);
        }
        return ret;
    }

    componentDidMount() { 
        this.getUserList();
    }

    render(){   
        return(
            <div className="page-container userMng-page">
                {this.state.loading && <LoadSpinner userClass="uc" /> }
                <div className="page-panel title">
                    <div className="title-content">
                        <div className="title-text">User Management</div>
                    </div>
                    <div className="title-icon-img">
                        <div className="icon-section img">
                            <div><i className="fas fa-users" /></div>
                        </div>
                        <div className="icon-section split">
                            <div className="block" />
                            <div className="lines" />
                        </div>
                    </div>
                </div>

                <div className="btn-container">
                    <div className="tro-btn btn add" onClick={this.newUser}>
                        <div className="btn-txt">Add User</div>
                        <div className="btn-icon">
                            <i className="fas fa-plus" />
                        </div>
                    </div>
                </div>

                <div className="page-panel user-table">
                    <ReactTableFixedColumns data={this.state.userList} columns={this.chartCol} defaultPageSize={5} showPagination={false} className="-striped"/>  :
                </div>

                {/* Sliding Panel */}
                <div className={"slider-container userMgt" + (this.state.displaySlider ? " open": "")} ref={this.sliderRef} style={{ bottom: this.getSelectHeight() }} >
                    <div className="slider-title">
                        <i className="title-icon fas fa-times" onClick={()=> this.setState({ displaySlider: false })}/>
                    </div>
                    <AccessPad submitKey={this.submitKey} saveTitle={"Set Password"}/>
                </div>
            </div>
        );
    }
}

export default UserManagement;